module.exports = __webpack_public_path__ + "img/JobSeeker.886182f4.svg";